document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.c_staff-coordinate-detail[data-leeep-tag-id]');
  if (!section || section.dataset.initialized === 'true') return;
  section.dataset.initialized = 'true';

  const tagId = section.dataset.leeepTagId;
  const paramName = section.dataset.coordIdParam || 'post_id';
  const area = section.querySelector('[data-leeep-area="staff-coordinate-detail"]');

  const urlParams = new URLSearchParams(window.location.search);
  const coordSlug = urlParams.get(paramName);

  const showMessage = (message) => {
    if (area) area.textContent = message;
  };

  if (!coordSlug) {
    showMessage('コーデが指定されていません。');
    return;
  }

  const renderLeeep = () => {
    if (!area || !tagId || typeof LeeepCite === 'undefined') return;
    area.textContent = '';
    const div = document.createElement('div');
    div.id = 'leeep-tag-' + String(tagId);
    area.appendChild(div);
    LeeepCite.init({
      tag_id: String(tagId),
      post_id: String(coordSlug)
    });
  };

  const waitForLeeep = (count = 0) => {
    if (typeof LeeepCite !== 'undefined') { renderLeeep(); return; }
    if (count > 50) {
      showMessage('コンテンツの読み込みに失敗しました。ページを再読み込みしてください。');
      return;
    }
    setTimeout(() => waitForLeeep(count + 1), 100);
  };

  if (tagId) waitForLeeep();

  // ========== LEEEP描画後の変換処理 ==========

  // LEEEPのデフォルト非表示要素
  const hideDefaults = () => {
    const brand = area.querySelector('.LeeepUserBrand');
    if (brand) brand.style.display = 'none';
    const date = area.querySelector('.LeeepDate');
    if (date) date.style.display = 'none';
  };

  // プロフィールの店舗名を「ブランド名 店舗名」にする（元の店舗名は data-shop-name に退避）
  const mergeUserBrandShop = () => {
    const shopNameEl = area.querySelector('.LeeepUserShopName');
    if (!shopNameEl || shopNameEl.dataset.brandName) return;
    const brandEl = area.querySelector('.LeeepUserBrandName');
    const brandName = brandEl ? (brandEl.textContent || '').trim() : '';
    const shopName = (shopNameEl.dataset.shopName || shopNameEl.textContent || '').trim();
    if (!shopName) return;
    shopNameEl.dataset.shopName = shopName;
    shopNameEl.dataset.brandName = brandName;
    if (brandName) shopNameEl.textContent = brandName + ' ' + shopName;
  };

  // スタッフ名に折り返し位置を足す（「shiori(161cm/24.5cm)」のように空白がないと折り返せないため）
  // 「(」の前と「/」の後ろに <wbr> を入れる。textContent は変わらない。
  const addUserNameBreakHints = () => {
    const nameEl = area.querySelector('.LeeepUserName');
    if (!nameEl || nameEl.dataset.breakHints === 'true') return;
    const text = nameEl.textContent || '';
    if (!text.trim()) return;
    const frag = document.createDocumentFragment();
    text.match(/[(（]?[^(（/／]*[/／]?/g).filter(Boolean).forEach((part, i) => {
      if (i > 0) frag.appendChild(document.createElement('wbr'));
      frag.appendChild(document.createTextNode(part));
    });
    nameEl.textContent = '';
    nameEl.appendChild(frag);
    nameEl.dataset.breakHints = 'true';
  };

  // ユーザーブロック再構成: フォローボタンを独立、画像 + SNSリストを1つのwrapperにまとめる
  const restructureUserBlock = () => {
    if (section.dataset.userRestructured === 'true') return;
    const user = area.querySelector('.LeeepUser');
    const userLink = area.querySelector('.LeeepUserLink');
    const snsList = area.querySelector('.LeeepStaffSnsLinkList');
    if (!user || !userLink || !snsList) return;

    const followBtn = snsList.querySelector('.LeeepFollowButton');
    if (followBtn) {
      user.appendChild(followBtn);
      const followText = followBtn.querySelector('.LeeepFollowButtonText');
      if (followText) followText.textContent = 'フォローする';
    }

    // 画像 + SNSリスト を1つの wrapper div にまとめてグリッドを単純化
    const media = document.createElement('div');
    media.className = 'c_staff-coordinate-detail__user-media';
    userLink.insertAdjacentElement('beforebegin', media);
    media.appendChild(userLink);
    media.appendChild(snsList);

    section.dataset.userRestructured = 'true';
  };

  // 身長 + 足サイズを挿入（/v3/staffs API）
  const appendFootSizeToUser = async () => {
    if (section.dataset.footAdded === 'true') return;
    if (typeof LeeepCite === 'undefined' || !LeeepCite.site_id) return;

    const userLink = area.querySelector('.LeeepUserLink');
    const href = userLink ? userLink.getAttribute('href') || '' : '';
    const m = href.match(/staff_id=([^&]+)/);
    if (!m) return;
    const staffId = decodeURIComponent(m[1]);

    // guard を fetch 開始前に即セット（2回発火で二重挿入されるのを防ぐ）
    section.dataset.footAdded = 'true';

    try {
      const res = await fetch(
        'https://cite.leeep.jp/v3/staffs?website_id=' + encodeURIComponent(LeeepCite.site_id)
        + '&staff_id=' + encodeURIComponent(staffId)
      );
      if (!res.ok) return;
      const data = await res.json();
      const staff = data && data.staffs && data.staffs[0];
      if (!staff) return;
      const props = staff.properties || staff.staff_properties
        || (staff.staff && staff.staff.properties) || [];
      const foot = props.find((p) => p && p.key && p.key.name === '足のサイズ');
      const footText = foot && foot.value
        ? (typeof foot.value === 'object' ? (foot.value.name || foot.value.code) : foot.value)
        : '';

      const heightEl = area.querySelector('.LeeepUserHeight');
      const existingHeight = heightEl ? (heightEl.textContent || '').trim() : '';

      let combined = '';
      if (existingHeight) combined += existingHeight;
      if (existingHeight && footText) combined += '/';
      if (footText) combined += footText + 'cm';

      if (!combined) return;

      if (heightEl) heightEl.style.display = 'none';

      // 既存の LeeepUserHeightFoot があれば再利用、なければ新規作成
      let infoEl = area.querySelector('.LeeepUserHeightFoot');
      if (infoEl) {
        infoEl.textContent = combined;
      } else {
        infoEl = document.createElement('div');
        infoEl.className = 'LeeepUserHeightFoot';
        infoEl.textContent = combined;
        const shopEl = area.querySelector('.LeeepUserShop');
        if (shopEl) shopEl.insertAdjacentElement('afterend', infoEl);
      }
    } catch (e) {
      console.warn('[c_staff-coordinate-detail] staff API failed:', e);
    }
  };

  // パンくず差し込み：スタッフコーデ一覧 > 店舗名 > スタッフ名 > コーデ詳細
  // 店舗名・スタッフ名は LEEEP 描画後のDOMから取得し、現在地(コーデ詳細)の手前に挿入する。
  // 店舗名: その店舗のスタッフ一覧 /pages/staff-list?shop_id= へリンク（店舗IDが取れなければリンクなしテキスト）。
  //   LEEEP の描画DOMには店舗IDが無いため、投稿API（/v3/posts）の投稿者の所属店舗から引く。
  // スタッフ名: staff_id があれば /pages/staff-ranking-detail?staff_id= へリンク。
  const SHOP_STAFF_LIST_URL = '/pages/staff-list';
  const normalizeShopName = (s) => String(s == null ? '' : s).trim().replace(/\s+/g, '').toLowerCase();
  const fetchShopId = async (shopName) => {
    if (typeof LeeepCite === 'undefined' || !LeeepCite.site_id) return '';
    try {
      const res = await fetch(
        'https://cite.leeep.jp/v3/posts?website_id=' + encodeURIComponent(LeeepCite.site_id)
        + '&post_id=' + encodeURIComponent(coordSlug)
      );
      if (!res.ok) return '';
      const data = await res.json();
      const post = data && data.posts && data.posts[0];
      const shops = (post && post.post_user && post.post_user.staff && post.post_user.staff.shops) || [];
      // 複数店舗に所属している場合は、表示中の店舗名と一致するものを使う
      const shop = shops.find((s) => s && normalizeShopName(s.name) === normalizeShopName(shopName))
        || (shops.length === 1 ? shops[0] : null);
      return shop && shop.id ? String(shop.id) : '';
    } catch (e) {
      console.warn('[c_staff-coordinate-detail] post API failed:', e);
      return '';
    }
  };

  // 店舗パンくずは先にテキストで出し、店舗IDが取れたらスタッフ一覧へのリンクに差し替える
  const linkStoreCrumb = async (crumbLi, shopName) => {
    const shopId = await fetchShopId(shopName);
    const span = crumbLi.querySelector('span.c_breadcrumb__link');
    if (!shopId || !span) return;
    const url = SHOP_STAFF_LIST_URL + '?shop_id=' + encodeURIComponent(shopId);
    const a = document.createElement('a');
    a.className = 'c_breadcrumb__link c_hover-opacity';
    a.href = url;
    a.textContent = span.textContent;
    span.replaceWith(a);
  };

  const makeCrumb = (text, url) => {
    const li = document.createElement('li');
    li.className = 'c_breadcrumb__item';
    let inner;
    if (url) {
      inner = document.createElement('a');
      inner.className = 'c_breadcrumb__link c_hover-opacity';
      inner.href = url;
    } else {
      inner = document.createElement('span');
      inner.className = 'c_breadcrumb__link';
    }
    inner.textContent = text;
    li.appendChild(inner);
    return li;
  };

  const insertBreadcrumbCrumbs = () => {
    if (section.dataset.breadcrumbCrumbsDone === 'true') return;
    const list = section.querySelector('.c_breadcrumb__list');
    const currentEl = section.querySelector('.c_breadcrumb__current');
    if (!list || !currentEl) return;
    const currentLi = currentEl.closest('.c_breadcrumb__item');
    if (!currentLi) return;

    const shopEl = area.querySelector('.LeeepUserShopName') || area.querySelector('.LeeepUserShop');
    const shopName = shopEl ? (shopEl.dataset.shopName || shopEl.textContent || '').trim() : '';
    const nameEl = area.querySelector('.LeeepUserName');
    const staffName = nameEl ? (nameEl.textContent || '').trim() : '';

    // どちらも未取得ならLEEEP未描画とみなして次回に委ねる
    if (!shopName && !staffName) return;

    const userLink = area.querySelector('.LeeepUserLink');
    const href = userLink ? userLink.getAttribute('href') || '' : '';
    const m = href.match(/staff_id=([^&]+)/);
    const staffId = m ? decodeURIComponent(m[1]) : '';

    const frag = document.createDocumentFragment();
    if (shopName) {
      const shopCrumb = makeCrumb(shopName, null);
      frag.appendChild(shopCrumb);
      linkStoreCrumb(shopCrumb, shopName);
    }
    if (staffName) {
      const staffUrl = staffId ? '/pages/staff-ranking-detail?staff_id=' + encodeURIComponent(staffId) : null;
      frag.appendChild(makeCrumb(staffName, staffUrl));
    }

    list.insertBefore(frag, currentLi);
    section.dataset.breadcrumbCrumbsDone = 'true';
  };

  // 見出し挿入：コーデタイトル / スタッフのコメント / 着用アイテム
  const insertHeadings = () => {
    if (section.dataset.headingsInserted === 'true') return;
    const secondary = area.querySelector('.LeeepPostDetailSecondary');
    if (!secondary) return;

    const firstProductName = area.querySelector('.LeeepProductList .LeeepProductName');
    if (firstProductName && firstProductName.textContent.trim()) {
      const titleText = firstProductName.textContent.trim();
      const h1 = document.createElement('h1');
      h1.className = 'c_staff-coordinate-detail__title';
      h1.textContent = titleText;
      secondary.insertBefore(h1, secondary.firstChild);

      // パンくず末尾「コーデ詳細」とページタイトルを商品名で動的更新
      // （LEEEP に投稿名が無いため商品名で代替。c_staff-blog-detail.js と同パターン）
      const breadcrumbCurrent = section.querySelector('.c_breadcrumb__current');
      if (breadcrumbCurrent) breadcrumbCurrent.textContent = titleText;
      document.title = titleText;
    }

    const captionSection = area.querySelector('.LeeepCaptionSection');
    if (captionSection && !captionSection.querySelector('.c_staff-coordinate-detail__section-heading')) {
      const h2 = document.createElement('h2');
      h2.className = 'c_staff-coordinate-detail__section-heading';
      h2.textContent = 'スタッフのコメント';
      captionSection.insertBefore(h2, captionSection.firstChild);
    }

    const productTitle = area.querySelector('.LeeepProductListTitle');
    if (productTitle) {
      productTitle.textContent = '着用アイテム';
      productTitle.classList.add('c_staff-coordinate-detail__section-heading');
    }

    section.dataset.headingsInserted = 'true';
  };

  // 戻るボタンを LEEEP の Secondary カラム末尾（商品セクションの下）に挿入
  const insertBackButton = () => {
    if (section.dataset.backInserted === 'true') return;
    const secondary = area.querySelector('.LeeepPostDetailSecondary');
    const tpl = section.querySelector('template[data-back-button-template]');
    if (!secondary || !tpl) return;
    secondary.appendChild(tpl.content.cloneNode(true));
    section.dataset.backInserted = 'true';
  };

  // メイン画像（Carousel）のスクロール位置から、対応するサムネイルに is-active を付与
  const trackActiveThumbnail = () => {
    if (section.dataset.thumbActiveBound === 'true') return;
    const carousel = area.querySelector('.LeeepCarousel');
    const thumbList = area.querySelector('.LeeepThumbnailList');
    if (!carousel || !thumbList) return;
    const thumbs = Array.from(thumbList.querySelectorAll(':scope > a'));
    if (!thumbs.length) return;

    const update = () => {
      const w = carousel.clientWidth;
      if (!w) return;
      const idx = Math.round(carousel.scrollLeft / w);
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
    };

    carousel.addEventListener('scroll', update, { passive: true });
    thumbs.forEach((t) => t.addEventListener('click', () => setTimeout(update, 50)));
    update();
    section.dataset.thumbActiveBound = 'true';
  };

  // ハッシュタグに共通クラス付与
  const decorateHashtags = () => {
    const hashtagSection = area.querySelector('.LeeepHashtagSection');
    if (!hashtagSection) return;
    hashtagSection.classList.add('c_hashtag-list');
    hashtagSection.querySelectorAll('.LeeepHashtag').forEach((el) => {
      el.classList.add('c_hashtag', 'c_hashtag--prefix');
      // LEEEP標準リンク（?hashtag=メンズ＝チップ式）を一覧のチェックボックス絞り込みに置換。
      // 絞り込み条件はURLではなく sessionStorage で渡す（c_custom-leeep.js が読み取り後に削除）。
      // URLに残すと LEEEP のフルページ送信で値が残り続け、クリア後の再送信で再適用される不具合になるため。
      // 冪等：再実行しても結果は同じ（リンク先・クリックハンドラの二重付与を防ぐ）。
      const name = (el.textContent || '').trim();
      if (!name) return;
      // LEEEP標準リンク（?hashtag=… 等）を初回に退避（再実行でhrefが上書き済みでも保持）。
      // sessionStorage が使えない環境（private mode 等）のフォールバック遷移先に使う。
      if (!el.dataset.cNativeHref) el.dataset.cNativeHref = el.getAttribute('href') || '';
      const nativeHref = el.dataset.cNativeHref;
      let path = '/pages/staff-coordinate';
      try { path = new URL(nativeHref || path, location.origin).pathname; } catch (e) { /* デフォルトを使用 */ }
      el.setAttribute('href', path);
      if (el.dataset.cFilterBound !== '1') {
        el.dataset.cFilterBound = '1';
        el.addEventListener('click', (e) => {
          // 中クリックや Cmd/Ctrl/Shift+クリック（新規タブ/ウィンドウ）は元タブが遷移しないため、
          // sessionStorage に値が残り別の一覧で誤消費される。書き込まずにそのまま遷移させる。
          if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey) return;
          // 宛先一覧を target で明示（3一覧でキー共有のためクロス消費を防ぐ）。
          let stored = false;
          try {
            sessionStorage.setItem('c_leeepPendingFilters', JSON.stringify({ target: 'staff-coordinate', values: [name] }));
            stored = true;
          } catch (err) { /* private mode / 容量超過等で失敗 */ }
          // sessionStorage が使えない場合は LEEEP標準リンクで遷移（チップ式表示になるが
          // 絞り込み・クリアは LEEEP 側で正常動作する）。素の一覧へ落とすより機能を維持する。
          if (!stored && nativeHref) {
            e.preventDefault();
            location.href = nativeHref;
          }
        });
      }
    });
  };

  // 商品カードをTabio版（?view=card-only）に差し替え
  const replaceProductCards = async () => {
    if (section.dataset.productsReplaced === 'true') return;
    const productList = area.querySelector('.LeeepProductList');
    if (!productList) return;

    const items = productList.querySelectorAll('a.LeeepProduct');
    if (!items.length) return;

    const fetchPromises = Array.from(items).map(async (item) => {
      const href = item.getAttribute('href') || '';
      const m = href.match(/\/products\/([^?#/]+)/);
      if (!m) return null;
      const handle = m[1];  // href から取った時点で既にURLエンコード済み
      try {
        const res = await fetch('/products/' + handle + '?view=card-only', {
          credentials: 'same-origin',
        });
        if (!res.ok) return null;
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const card = doc.querySelector('[data-product-card-root]');
        return card ? card.outerHTML : null;
      } catch (e) {
        console.warn('[c_staff-coordinate-detail] card fetch failed for', handle, e);
        return null;
      }
    });

    const cards = await Promise.all(fetchPromises);
    const validCards = cards.filter(Boolean);
    if (!validCards.length) return;

    const newList = document.createElement('div');
    newList.className = 'LeeepProductList c_staff-coordinate-detail__product-list';
    validCards.forEach(card => {
      newList.insertAdjacentHTML('beforeend', card);
    });

    productList.replaceWith(newList);

    section.dataset.productsReplaced = 'true';

    // 動的挿入したカードのレビュー星を描画
    // 正しいAPI: window.leeepRenderReviewStarsOnProductMarkers()
    // （window.renderLeeepReviewStars() はラッパー、どちらでも動く）
    const rescanReviews = () => {
      try {
        if (typeof window.leeepRenderReviewStarsOnProductMarkers === 'function') {
          window.leeepRenderReviewStarsOnProductMarkers();
        } else if (typeof window.renderLeeepReviewStars === 'function') {
          window.renderLeeepReviewStars();
        }
      } catch (e) { /* noop */ }
    };
    rescanReviews();
    // LEEEP の星描画関数は商品カード DOM が確定してから呼ぶ必要があるため、
    // newList 内の LeeepReviewScoreMarker 出現/属性更新を MutationObserver で検知
    const reviewObserver = new MutationObserver(() => {
      if (newList.querySelector('.LeeepReviewScoreMarker')) {
        rescanReviews();
      }
    });
    reviewObserver.observe(newList, { childList: true, subtree: true, attributes: true });
    // フェイルセーフ: 5秒で停止
    setTimeout(() => reviewObserver.disconnect(), 5000);
  };

  // LEEEP描画完了検知
  const detailReadyObserver = new MutationObserver(() => {
    const caption = area && area.querySelector('.LeeepCaption');
    const productItem = area && area.querySelector('.LeeepProductList .LeeepProduct');
    if (caption && productItem) {
      hideDefaults();
      mergeUserBrandShop();
      addUserNameBreakHints();
      restructureUserBlock();
      insertHeadings();
      insertBreadcrumbCrumbs();
      decorateHashtags();
      appendFootSizeToUser();
      replaceProductCards();
      insertBackButton();
      trackActiveThumbnail();
      detailReadyObserver.disconnect();
    }
  });
  if (area) detailReadyObserver.observe(area, { childList: true, subtree: true });

  document.addEventListener('onLeeepContentsRendered', () => {
    hideDefaults();
    mergeUserBrandShop();
    addUserNameBreakHints();
    restructureUserBlock();
    insertHeadings();
    insertBreadcrumbCrumbs();
    decorateHashtags();
    appendFootSizeToUser();
    replaceProductCards();
    insertBackButton();
  });
});

/* TABIO-1365: supplement LEEEP's post products with their storefront descriptions. */
(() => {
  const init = () => {
    const section = document.querySelector('.c_staff-coordinate-detail');
    if (!section) return;
    const products = new Map();
    let scheduled = false;
    const hasType = (entity, type) => entity && typeof entity === 'object' &&
      [].concat(entity['@type'] || []).includes(type);
    const entities = (data) => Array.isArray(data) ? data.flatMap(entities) :
      data && typeof data === 'object' ? [data, ...entities(data['@graph'])] : [];
    const text = (value) => String(value || '').replace(/\s+/g, ' ').trim();
    const plainDescription = (value) => {
      const doc = new DOMParser().parseFromString(String(value || ''), 'text/html');
      doc.querySelectorAll('script, style').forEach((node) => node.remove());
      return text(doc.body.textContent);
    };
    const productPath = (value) => {
      try {
        const url = new URL(value, window.location.origin);
        return url.origin === window.location.origin &&
          /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+\/?$/i.test(url.pathname)
          ? url.pathname.replace(/\/$/, '') : '';
      } catch (_) { return ''; }
    };
    const isCurrentPost = (entity) => {
      if (!hasType(entity, 'BlogPosting') || typeof entity.url !== 'string') return false;
      try {
        const url = new URL(entity.url, window.location.origin);
        const current = new URL(window.location.href);
        const param = section.dataset.coordIdParam || 'post_id';
        return url.origin === current.origin && url.pathname === current.pathname &&
          !!current.searchParams.get(param) && url.searchParams.get(param) === current.searchParams.get(param);
      } catch (_) { return false; }
    };
    const supplement = () => {
      const linked = [...products.values()];
      if (!linked.some((entry) => entry.data)) return;
      document.querySelectorAll('script[type="application/ld+json"]').forEach((script) => {
        let data;
        try { data = JSON.parse(script.textContent); } catch (_) { return; }
        let changed = false;
        entities(data).filter(isCurrentPost).forEach((post) => {
          [].concat(post.about || []).forEach((product) => {
            if (!hasType(product, 'Product') ||
                (typeof product.description === 'string' && product.description.trim())) return;
            const path = productPath(product.url || product['@id'] || '');
            const matches = linked.filter((entry) => path ? entry.path === path :
              entry.names.has(text(product.name)) || (entry.data && text(entry.data.title) === text(product.name)));
            // A name is only safe to use when it identifies exactly one linked product.
            if (matches.length !== 1) return;
            const description = matches[0].data?.description;
            if (!description) return;
            product.description = description;
            changed = true;
          });
        });
        if (changed) script.textContent = JSON.stringify(data).replace(/</g, '\\u003c');
      });
    };
    const scan = () => {
      scheduled = false;
      section.querySelectorAll('.LeeepProductList a[href]').forEach((link) => {
        const path = productPath(link.getAttribute('href'));
        if (!path) return;
        let entry = products.get(path);
        if (!entry) {
          entry = { path, names: new Set(), data: null };
          products.set(path, entry);
          fetch(path + '.js', { credentials: 'same-origin' })
            .then((response) => response.ok ? response.json() : null)
            .then((product) => {
              if (!product || !product.title) return;
              const description = plainDescription(product.description);
              if (description) entry.data = { title: product.title, description };
              supplement();
            }).catch(() => { /* Keep the original markup when a product cannot be read. */ });
        }
        const name = link.querySelector('.LeeepProductName')?.textContent ||
          (link.matches('.c_product-item-meta__title') ? link.textContent : '');
        if (text(name)) entry.names.add(text(name));
      });
      supplement();
    };
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(scan);
    };
    const isJsonScript = (node) => node?.nodeType === 1 &&
      node.matches?.('script[type="application/ld+json"]');
    const observer = new MutationObserver((records) => {
      if (records.some((record) => section.contains(record.target) || isJsonScript(record.target) ||
          isJsonScript(record.target.parentElement) || [...record.addedNodes].some((node) =>
            isJsonScript(node) || (node.nodeType === 1 && node.querySelector?.('script[type="application/ld+json"]'))))) schedule();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    document.addEventListener('onLeeepContentsRendered', schedule);
    scan();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
